import React, { useState, useEffect } from "react";
import SearchIcon from "@material-ui/icons/Search";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import Button from "@material-ui/core/Button";
import PropTypes from "prop-types";
import CloseIcon from "@material-ui/icons/Close";
import Box from "@material-ui/core/Box";

import useStyles from "./styles";
import {
  setDataStorage,
  filterInputValue,
} from "../../utils/filterManagementDataStore";

function SearchOCField({ handleSearch, disabled, isClearable }) {
  const classes = useStyles();
  const [ocValue, setOcValue] = useState("");
  const [searchead, setSearchead] = useState(false);

  function searchOC() {
    if (searchead && isClearable) {
      setOcValue("");
      handleSearch("");
    } else {
      handleSearch(ocValue);
    }
    setSearchead(!searchead);
  }

  useEffect(() => {
    const oc = filterInputValue("document_oc");
    if (oc) {
      setOcValue(oc);
    }
  }, [setOcValue]);

  return (
    <Box style={{ width: 250 }}>
      <h4 className={classes.ocBoxLabel}>Ordem de Carregamento</h4>
      <div className={classes.ocBox}>
        <TextField
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          data-cy="field-oc"
          id="field-oc"
          value={ocValue}
          disabled={disabled || (isClearable && searchead)}
          className={classes.ocInputField}
          placeholder="Digite a OC"
          onChange={(event) => {
            setOcValue(event.target.value);
            setDataStorage("document_oc", event.target.value);
          }}
          onKeyUp={(event) => event.keyCode}
          fullwidth
          size="small"
          variant="outlined"
        />
        <Button
          disabled={disabled}
          variant="contained"
          color="primary"
          className={classes.smButton}
          size="medium"
          data-cy="search-oc-btn"
          id="search-oc-btn"
          onClick={searchOC}
          startIcon={<SearchIcon />}
        >
          {isClearable && searchead ? <CloseIcon /> : "Consultar OC"}
        </Button>
      </div>
    </Box>
  );
}

SearchOCField.propTypes = {
  handleSearch: PropTypes.func.isRequired,
  isClearable: PropTypes.bool,
  disabled: PropTypes.bool,
};

SearchOCField.defaultProps = {
  disabled: false,
  isClearable: true,
};

export default SearchOCField;
